/*
 *   File : why-subscription.js
 *   Author : https://evoqins.com
 *   Description : why subscription details modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo } from "react";

// Components
import { Icon } from "../Icon";


function WhySubscriptionModal(props) {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("why-subscription-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade"
            id="why-subscription-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="why-subscription-modal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='why-subscription-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 p-3 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center p-0">
                        <h6 className="e-alt-font-lato e-font-16 e-text-chinese-black e-font-weight-700 line-height-24px mb-0">
                            Why is Subscription Required?
                        </h6>
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body p-0 pt-3 pe-lg-4'>
                        <p className='e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-22px'>
                            Subscribing to our baskets ensures you get the most tailored and optimal investment options.
                            It allows us to provide you with premium features and personalized support,
                            maximizing your investment potential.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(WhySubscriptionModal);